export default "__VITE_ASSET__CeZ2psEH__"